
let $FORM;
let $SHOP;
let $SUMMARY;
let $DELIVERY
let $DELIVERYINPUT
let $DELIVERYFEE
let $DELIVERYADDRESS
let $DELIVERYINFORMATION
let $PAYMENTRADIO
let $PAYBUTTON
let currency;
let deliveryFee;
let deliveryTotal;

function plus() {
    let input = $(this).prev().find('input')
    let inputVal = input.val()
    let newVal = parseFloat(inputVal) + 1;
    input.val(newVal)
    checkSummary(input)
}

function minus() {
    let input = $(this).next().find('input')
    let inputVal = input.val()
    if (inputVal > 0) {
        let newVal = parseFloat(inputVal) - 1;
        input.val(newVal)
        checkSummary(input)
    }
}

function summaryPlus() {
    let input = $('.ps-shop-section').eq($(this).data('quantity-section')).find('#' + $(this).data('quantity-id'))
    let inputVal = input.val()
    let newVal = parseFloat(inputVal) + 1;
    input.val(newVal)
    checkSummary(input)
}

function summaryMinus() {
    let input = $('.ps-shop-section').eq($(this).data('quantity-section')).find('#' + $(this).data('quantity-id'))
    let inputVal = input.val()
    if (inputVal > 0) {
        let newVal = parseFloat(inputVal) - 1;
        input.val(newVal)
        checkSummary(input)
    }
}

function checkSummary(input) {
    let item = {
        section: input.closest('.ps-shop-section').index(),
        id: input.attr('id'),
        name: input.closest('.ps-shop-list__item').find('h3').text(),
        quantity: Number(input.val()),
        price: input.closest('.ps-shop-list__item-details').find('.ps-shop-list__item-price span').text(),
        total: Math.round((Number(input.val()) * input.closest('.ps-shop-list__item-details').find('.ps-shop-list__item-price span').text() + Number.EPSILON) * 100) / 100 
    }
    let summaryListItem = $SUMMARY.find(`#section-${item.section}_id-${item.id}-summary`)
    if (summaryListItem.length > 0) {
        if (item.quantity == 0) {
            removeItem(item)
        } else {
            updateItem(item)
        }
    } else {
        addItem(item)
    }
    addTotal()
}

function addItem(item) {
    $SUMMARY.append(`<li id="section-${item.section}_id-${item.id}-summary"><div class="ps-shop-summary__item-quantity"><button type="button" class="ps-quantity-button ps-quantity-button__minus" data-quantity-section="${item.section}" data-quantity-id="${item.id}">-</button><span>${item.quantity}</span><button type="button" class="ps-quantity-button ps-quantity-button__plus" data-quantity-section="${item.section}" data-quantity-id="${item.id}">+</button></div><strong>${item.name}</strong><div class="ps-shop-summary__item-price">${currency}<span>${item.total.toFixed(2)}</span></div></li>`)
}

function removeItem(item) {
    $(`#section-${item.section}_id-${item.id}-summary`).remove()
}

function updateItem(item) {
    let summaryItem = $(`#section-${item.section}_id-${item.id}-summary`)
    summaryItem.find('.ps-shop-summary__item-quantity span').text(item.quantity)
    summaryItem.find('.ps-shop-summary__item-price span').text(item.total.toFixed(2))
}

function addTotal() {
    let subTotal = 0
    $SUMMARY.children().each(function () {
        subTotal += Number($(this).find('.ps-shop-summary__item-price span').text())
    });
    let roundedsubTotall = Math.round((Number(subTotal) + Number.EPSILON) * 100) / 100
    let size
    if (roundedsubTotall >= 1000) {
        size = 7
    } else if (roundedsubTotall >= 100) {
        size = 6
    } else if (roundedsubTotall >= 10) {
        size = 5
    } else {
        size = 4
    }
    if (roundedsubTotall != 0 && roundedsubTotall >= deliveryTotal) {
        $('.ps-summary__totals-total span').addClass('field-validation-valid').removeClass('field-validation-error')
    }
    $('.ps-shop-summary__totals-sub input[type=text]').val(roundedsubTotall.toFixed(2)).attr('size', size)
    let total = deliveryTotal + roundedsubTotall
    $('#ps-summary-total input[type=text]').val(total.toFixed(2)).attr('size', size)
}

function updateDelivery() {
    if (this.value == 'delivery') {
        $DELIVERYINPUT.val(deliveryFee.toFixed(2))
        $DELIVERYFEE.show()
        $DELIVERYADDRESS.show()
        $DELIVERYINFORMATION.show()
        deliveryTotal = deliveryFee
    } else if (this.value == 'collection') {
        $DELIVERYINPUT.val('0.00')
        $DELIVERYFEE.hide()
        $DELIVERYADDRESS.hide()
        $DELIVERYINFORMATION.hide()
        deliveryTotal = 0
    }
    addTotal()
}

function initDelivery() {
    let delivery
    if ($('input[name="Form.Delivery"]').is(':radio')) {
        delivery = $('input[name="Form.Delivery"]:checked').val()
    } else {
        delivery = $('input[name="Form.Delivery"]').val()
    }
    if (delivery == 'collection') {
        $DELIVERYINPUT.val('0.00')
        $DELIVERYADDRESS.hide()
        $DELIVERYFEE.hide()
        deliveryTotal = 0
    } else {
        $DELIVERYINPUT.val(deliveryFee.toFixed(2))
        $DELIVERYADDRESS.show()
        $DELIVERYFEE.show()
        deliveryTotal = deliveryFee
    }
    addTotal()
}

function updatePayment() {
    if ($('input[name="Form.Payment"]:checked').val() == 'now') {
        $PAYBUTTON.val('Proceed to payment')
    } else if ($('input[name="Form.Payment"]:checked').val() == 'later') {
        $PAYBUTTON.val('Submit your order')
    }
}

function formSubmit() {
    if ($FORM.valid()) {
        $('.ps-loader').show()
    }
}

function initPayment() {
    let payment
    if ($('input[name="Form.Payment"]').is(':radio')) {
        payment = $('input[name="Form.Payment"]:checked').val()
    } else {
        payment = $('input[name="Form.Payment"]').val()
    }
    if (payment == 'now') {
        $PAYBUTTON.val('Proceed to payment')
    } else {
        $PAYBUTTON.val('Submit your order')
    }
}

export default class Shop {
    constructor() {
        $FORM = $('.ps-shop').parent()
        $SHOP = $('.ps-shop')
        $SUMMARY = $('#ps-shop-summary__list')
        $DELIVERY = $('input[name="Form.Delivery"]')
        $DELIVERYINPUT = $('.ps-shop-summary__totals-delivery input')
        $DELIVERYFEE = $('.ps-shop-summary__totals-delivery')
        $DELIVERYADDRESS = $('#ps-delivery-address')
        $DELIVERYINFORMATION = $('.ps-delivery__content ul')
        $PAYMENTRADIO = $('input[type=radio][name="Form.Payment"]')
        $PAYBUTTON = $('#ps-pay-button')
        currency = $('#ps-summary-total').text()
        deliveryFee = parseFloat($('input[name=delivery-fee]').val())
        deliveryTotal = 0;
    }

    init() {
        initPayment()
        initDelivery()
        $SHOP.on('click', '.ps-quantity-button__minus', minus)
        $SHOP.on('click', '.ps-quantity-button__plus', plus)
        $SUMMARY.on('click', '.ps-quantity-button__minus', summaryMinus)
        $SUMMARY.on('click', '.ps-quantity-button__plus', summaryPlus)
        $DELIVERY.on('change', updateDelivery)
        $PAYMENTRADIO.on('change', updatePayment)
        $FORM.on('submit', formSubmit)
    }
}



// WEBPACK FOOTER //
// ./js/modules/Shop.js